export let VisualElementType = {
    MESH: 0,
    LINE: 1,
    POINT: 2,
    TEXT: 3,
    ARROW: 4,
    TRANSFORM: 5,
    RAYCAST: 6,
    TORUS: 7
};